export const RESET_STORE = 'RESET_STORE';
export const RESET_FROM = 'RESET_FROM';
export const SET_STEP = 'SET_STEP';
export const NEXT_STEP = 'NEXT_STEP';
export const PREV_STEP = 'PREV_STEP';
export const UPDATE_SURVEY = 'UPDATE_SURVEY';
export const CHECK_LAST_STEP = 'CHECK_LAST_STEP';

export function resetStore(payload) {
  return { type: RESET_STORE, payload };
}

export function resetFrom(payload) {
  return { type: RESET_FROM, payload };
}

export function setStep(payload) {
  return { type: SET_STEP, payload };
}

export function nextStep(payload) {
  return { type: NEXT_STEP, payload };
}

export function prevStep(payload) {
  return { type: PREV_STEP, payload };
}

export function updateSurvey(payload) {
  return { type: UPDATE_SURVEY, payload };
}

export function checkLastStep(payload) {
  return { type: CHECK_LAST_STEP, payload };
}
